import notification, { NotificationPlacement } from "antd/lib/notification";
import { NOTIFICATION_TYPES } from "../../../config/constants";
import NotificationService from "../../../services/notifications/NotificationsService";

const openNotificationDialog = ({
  message,
  description,
  type,
  placement = "bottomRight",
  logError,
}: {
  message?: string;
  description?: string;
  type: number;
  placement?: NotificationPlacement;
  logError: boolean;
}) => {

  switch (type) {
    case NOTIFICATION_TYPES.SUCCESS:
      if (!message) {
        message = `Success`;
      }
      if (!description) {
        description = `Action has been successfully executed.`;
      }
      if (!placement) {
        placement = `bottomRight`;
      }
      notification.success({
        message: message,
        description:
          description.length > 500
            ? description.slice(0, 500) + "..."
            : description,
        placement,
        style: { marginBottom: 60, marginRight: 20, zIndex: 9999999 },
      });
      break;
    case NOTIFICATION_TYPES.ERROR:
      if (!message) {
        message = `Error`;
      }
      if (!description) {
        description = `Execution has failed.`;
      }
      if (!placement) {
        placement = `bottomRight`;
      }
      notification.error({
        message: message,
        description:
          description.length > 500
            ? description.slice(0, 500) + "..."
            : description,
        placement,
        style: { marginBottom: 60, marginRight: 20, zIndex: 9999999 },
      });
      if (logError) {
        NotificationService.create({
          definitionId: 1,
          customValue: JSON.stringify(description),
          account: "admin@tillit.be",
        });
      }
      break;
    case NOTIFICATION_TYPES.INFO:
      if (!message) {
        message = `Info`;
      }
      if (!description) {
        description = `Needs to be implemented.`;
      }
      if (!placement) {
        placement = `bottomRight`;
      }
      notification.info({
        message: message,
        description:
          description.length > 500
            ? description.slice(0, 500) + "..."
            : description,
        placement,
        style: { marginBottom: 60, marginRight: 20, zIndex: 9999999 },
      });
      break;
  }
};

const NotificationsUtil = {
  openNotificationDialog,
};
export default NotificationsUtil;
